/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import { Link } from 'react-router';
import Auth from '@aws-amplify/auth';
import clone from 'clone';
import moment from 'moment-timezone';
import {
  Button,
  Container,
  Dropdown,
  Grid,
  Icon,
  Menu,
  Popup,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import config from '../../../../config';
// actions
import { promptChangesMessage } from '../../../actions/prompt';
// import { fetchBobForms } from '../../../actions/bobForms';
import { fetchTemplates } from '../../../actions/templates';
// constants
import { DEFAULT_PROMPT } from '../../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
// components
import NavBar from '../../../components/NavBar';
import AutoReleaseTimer from '../../../components/Bookings/AutoReleaseTimer';
import BookingSectionTab from '../../../components/Bookings/BookingSectionTab';
// sections
import Info from './Info';
import Purchaser from './Purchaser';
import Documents from './Documents';
import Tracker from './Tracker';
import Buyer from './Buyer';
import PaymentPlan from './PaymentPlan';
// structs
import BOOKING_DEFAULT from '../../../structs/booking';
// utils
import { decodeSearch, encodeSearch } from '../../../utils/url';
import { fetchM } from '../../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../../../actions/flash';
import { CANCELLED_BOOKING_STATUSES, isBookingPendingCancellation } from '../../../constants/bookingStatuses';
import FormSharingModal from '../../modals/FormSharingModal';
import OpportunityCancelModal from '../../../components/OpportunityCancelModal';
import { isCountryVietnam } from '../../../constants/countries';
import { hasVietnamElevatedAccess, isVietnamCompany } from '../../../utils/vietnam';

const isPRS = config.get('prs');

class Overview extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        noeticIsEnabled: PropTypes.bool,
        lawyerIsEnabled: PropTypes.bool,
        settings: PropTypes.shape({
          bookingHideLoanTracker: PropTypes.bool,
        }),
      }),
    }),
    auth: PropTypes.shape({
      companyBranch: PropTypes.shape({
        id: PropTypes.number,
      }),
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
    }),
    routeParamsID: PropTypes.string,
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    bobForms: PropTypes.shape({
      data: PropTypes.array,
    }),
    templates: PropTypes.shape({
      data: PropTypes.shape({
        print: PropTypes.array,
      }),
    }),
    fetchNewBooking: PropTypes.func,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    onCheck: PropTypes.func,
    checkHasChanges: PropTypes.func,
    token: PropTypes.string,
    t: PropTypes.func,
    // CPI-974 (E): supplied by containers/Bookings/Bookings.jsx, undefined off Vietnam.
    opportunity: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    onRequestBookingCancellation: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
    bobForms: state.bobForms,
    templates: state.templates,
  })
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const query = decodeSearch(props.location.search);
    const isMobile = windowWidth < 768;
    const loading = props.loading;
    const hideLoanTracker = props.appConfig && props.appConfig.data && props.appConfig.data.settings && props.appConfig.data.settings.bookingHideLoanTracker;
    const data = Object.assign({}, BOOKING_DEFAULT, props.data);
    const isMalaysia = props.auth && props.auth.company && props.auth.company.countryCode.toUpperCase() === 'MY';
    let tabID = 1;
    switch (query.section) {
      case 'info':
        tabID = 1;
        break;
      case 'purchaser':
        tabID = 2;
        break;
      case 'tracker':
        tabID = 3;
        break;
      case 'payment_plan':
        tabID = 4;
        break;
      case 'documents':
        tabID = 5;
        break;
      case 'logs':
        tabID = 6;
        break;
      case 'buyer':
        tabID = 7;
        break;
      default:
        tabID = 1;
        break;
    }
    // CPI-974 (AC16): with the tab gone, ?section=buyer would still have rendered the panel.
    if (tabID === 7 && isVietnamCompany(props.auth)) {
      tabID = 1;
    }
    // CPI-976: Vietnam's E-Sign is hidden on the Purchaser tab; the description should not mention it.
    const sectionTabs = [
      { id: 1, title: 'Info', description: 'Status, Pricing & Payment' },
      { id: 2, title: 'Purchaser', description: isVietnamCompany(props.auth) ? 'Details & Eligibility' : 'Details, E-Sign & Eligibility' },
      { id: 3, title: 'Tracker', description: 'Loan & SPA/LA Tracker', disabled: hideLoanTracker },
    ];
    sectionTabs.push(
      ...(!isMalaysia
        ? [{
          id: 4,
          title: 'Payment Plan',
          description: 'Pending Selection',
          disabled: data.project && !data.project.paymentPlanFlow,
        }]
        : []),
      { id: 5, title: 'Documents', description: 'Document Sharing' },
      { id: 6, title: 'Logs', description: 'Activity Logs', page: 'activities/' },
    );
    // CPI-974 (AC16): Vietnam has no MHub Buyer App, and the buyerProfileID arm means the
    // project flag alone would still show the tab on a booking that was linked earlier.
    if (!isVietnamCompany(props.auth) &&
      (data.buyerProfileID || (data.project.linkBuyerApp && !CANCELLED_BOOKING_STATUSES.some(s => data.statusID === s.value)))) {
      sectionTabs.push({ id: 7, title: 'Buyer App', description: 'Status & Progress' });
    }
    return {
      data,
      isMobile,
      loading,
      oriData: clone(data),
      tabID,
      sectionTabs,
      refreshPage: false,
    };
  }
  constructor(props) {
    super(props);
    const state = Overview.getPropsToState(props);
    this.state = {
      ...state,
      printTemplates: [],
      projectToken: '',
      systemData: [],
      isAutoReleaseTimerEnabled: false,
      isAgingARTimerEnabled: false,
      showShareEmailModal: false,
      project: [],
      allBankCases: [],
      hasDropCase: false,
      maUserAffiliateCompanyBranchName: '',
      docxPrintTemplates: [],
      isPrinting: false,
      showCancelModal: false,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchTemplates('print', true));
    // store.dispatch(fetchBobForms(true));
  }
  componentDidMount() {
    if (!isPRS) {
      this.fetchSystemSettings();
    }
    if (this.state.data && this.state.data.id) {
      this.fetchPrintTypes();
      this.getBookingPaymentPlan(this.state.data.id);
      this.fetchDocxTemplates(this.state.data);
    }
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = Overview.getPropsToState(nextProps);
    const isOriDataSame = JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData);
    const isDataSame = JSON.stringify(this.state.data) === JSON.stringify(state.data);

    if (isOriDataSame) {
      state.data = this.state.data;
      state.bookingPaymentPlan = this.state.bookingPaymentPlan;
      state.sectionTabs = this.state.sectionTabs;
    }

    if (!isDataSame) {
      this.handleFetchAllBankCases(state.data);
      if (this.state.data.maUserAffiliateCompanyBranchID !== state.data.maUserAffiliateCompanyBranchID) {
        this.fetchMaUserAffiliateCompanyBranch(state.data.maUserAffiliateCompanyBranchID);
      }
    }

    this.setState({ ...state }, () => {
      if (!isOriDataSame && state.data.id) {
        this.fetchPrintTypes();
        this.getBookingPaymentPlan(state.data.id);
        this.fetchDocxTemplates(state.data);
      }
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  checkAllowPrint = (data) => {
    const { isBranchLeader, isHeadquarters } = this.props.auth;
    const isCancelledStatus = data.statusID === 'cancelled_developer' || data.statusID === 'cancelled_availability';

    if ((data.project.projectFormAccessibilities && data.project.projectFormAccessibilities.length > 0 && data.statusID) || (this.state.docxPrintTemplates && this.state.docxPrintTemplates.length && data.statusID)) {
      if (data.project.hidePrintAgentStaff) {
        // If HidePrintAgentStaff is ticked && booking is under Reserved OR Cancelled status && isBranchLeader or HQ then allow print
        if ((data.statusID === 'reserved' || isCancelledStatus) && (isBranchLeader || isHeadquarters)) {
          return true;
        }
        // If HidePrintAgentStaff is ticked && booking is under Booked or Sold status then allow print for all
        if (data.statusID === 'booked' || data.statusID === 'sold_spa_signed') {
          return true;
        }
      } else {
        // If HidePrintAgent is not ticked and not PRS server, then allow print
        if (!isPRS) return true;
        // If HidePrint is not ticked, is PRS server && statusID is booked OR sold, then allow print
        if (
          (data.project.projectFormAccessibilities && data.project.projectFormAccessibilities.length > 0 &&
            (
              (data.statusID && data.statusID === 'booked') ||
              (data.statusID && data.statusID === 'sold_spa_signed') ||
              isCancelledStatus ||
              this.hasAccess()
            )
          ) ||
          (this.state.docxPrintTemplates && this.state.docxPrintTemplates.length > 0 &&
            (
              (data.statusID && data.statusID === 'booked') ||
              (data.statusID && data.statusID === 'sold_spa_signed') ||
              isCancelledStatus ||
              this.hasAccess()
            )
          )
        ) {
          return true;
        }
      }
    }
    return false;
  }
  // CPI-974 (E): the Sales Overview cancel action. Vietnam only, SA / HQ family only, and only
  // when the booking has a CRM opportunity behind it.
  canShowVNCancel = () => {
    const { auth, opportunity } = this.props;
    return isCountryVietnam(auth.company.countryCode) &&
      hasVietnamElevatedAccess(auth) &&
      !!(opportunity && opportunity.id);
  }
  // The cancel action no longer writes to the opportunity, so "already requested/cancelled" is
  // read off the booking itself rather than opportunity.sr_status; shares book-api's own
  // pending-cancellation predicate so a decline (which only stamps declinedPendingCancellationAt,
  // not clear pendingCancellation) re-enables the button the same way the Sales list treats it.
  isVNCancelInProgress = () => {
    const { data } = this.state;
    if (!data) return false;
    if (CANCELLED_BOOKING_STATUSES.some(s => data.statusID === s.value)) return true;
    return isBookingPendingCancellation(data);
  }
  handleOpenCancelModal = () => {
    this.setState({ showCancelModal: true });
  }
  handleCloseCancelModal = () => {
    this.setState({ showCancelModal: false });
  }
  renderCancelAction = () => {
    if (!this.canShowVNCancel()) return null;
    const { t } = this.props;
    const { isMobile } = this.state;
    const inProgress = this.isVNCancelInProgress();
    const button = (
      <Button
        className="ui medium compact button icon"
        icon
        labelPosition={isMobile ? '' : 'left'}
        disabled={inProgress}
        onClick={this.handleOpenCancelModal}
        style={{ height: '30px', verticalAlign: 'middle', fontSize: '12px' }}
      >
        <Icon name="times circle outline" color={inProgress ? 'grey' : 'red'} fitted={isMobile} />
        {isMobile ? '' : t('Cancel Booking', { ns: TRANSLATION_FILES.translation })}
      </Button>
    );
    if (!inProgress) return button;
    return (
      <Popup
        content={t('A cancellation request is already in progress', { ns: TRANSLATION_FILES.translation })}
        trigger={<div style={{ display: 'inline-block' }}>{button}</div>}
      />
    );
  }
  renderCancelModal = () => {
    if (!this.canShowVNCancel()) return null;
    const { opportunity, onRequestBookingCancellation } = this.props;
    return (
      <OpportunityCancelModal
        open={this.state.showCancelModal}
        srCode={opportunity.sr_code}
        onClose={this.handleCloseCancelModal}
        onSubmit={(status, reason, cancellationType) =>
          onRequestBookingCancellation(reason, cancellationType)}
      />
    );
  }
  checkICIsImage = (customer) => {
    let isImage = customer.icFrontDocumentID !== '' || customer.icBackDocumentID !== '';
    if (customer.icFrontDocumentID !== '' && customer.icFrontDocument && customer.icFrontDocument.name) {
      // NOTE: this checking will not work if filename don't hav extension
      if (customer.icFrontDocument.name.toLowerCase().includes('.pdf')) isImage = false;
    }
    if (customer.icBackDocumentID !== '' && customer.icBackDocument && customer.icBackDocument.name) {
      // NOTE: this checking will not work if filename don't hav extension
      if (customer.icBackDocument.name.toLowerCase().includes('.pdf')) isImage = false;
    }
    return isImage;
  }

  checkIfCompanyBranchAllowedToViewForm = (formAccessibility) => {
    const { auth } = this.props;
    // empty company branch IDs means accessible to all
    if (formAccessibility && (!formAccessibility.companyBranchIDs || formAccessibility.companyBranchIDs.length === 0)) {
      return true;
    }
    if (formAccessibility && formAccessibility.companyBranchIDs && auth.companyBranch && auth.companyBranch.id && formAccessibility.companyBranchIDs.includes(auth.companyBranch.id)) {
      return true;
    }
    return false;
  }

  checkIfBookingStatusAllowedToViewForm = (formAccessibility, booking) => {
    if (booking.statusID === 'expired') {
      return true;
    }
    switch (booking.statusID) {
      case 'reserved':
        return formAccessibility && formAccessibility.isEnabledOnReserved;
      case 'booked':
        return formAccessibility && formAccessibility.isEnabledOnBooked;
      case 'cancelled_developer':
      case 'cancelled_availability':
        return formAccessibility && (formAccessibility.isEnabledOnCancelled === undefined || formAccessibility.isEnabledOnCancelled);
      case 'sold_spa_signed':
        return formAccessibility && formAccessibility.isEnabledOnSold;
      default:
        return false;
    }
  }

  checkIfFormAccessibleToViewForm = (currentPFA, booking) => {
    const { data } = this.state;
    const formAccessibilities = data && data.project && data.project.projectFormAccessibilities ? data.project.projectFormAccessibilities : [];
    const pfaIdx = formAccessibilities.findIndex(fa => fa.templateID === currentPFA.templateID);
    if (pfaIdx !== -1) {
      const selectedPfa = formAccessibilities[pfaIdx];
      const isCompanyBranchAllowedToView = this.checkIfCompanyBranchAllowedToViewForm(selectedPfa);
      const isBookingStatusAllowedToView = this.checkIfBookingStatusAllowedToViewForm(selectedPfa, booking);
      return isCompanyBranchAllowedToView && isBookingStatusAllowedToView;
    }
    return false;
  }
  setLoading = (loading = false, loadingType) => new Promise((res) => {
    if (loadingType === 'validatingTIN') {
      this.setState({ validatingTin: loading }, res);
    } else {
      this.setState({ loading }, res);
    }
  })
  fetchPrintTypes = () => {
    const { templates, t } = this.props;
    const { data } = this.state;
    const output = [];
    if (data
      && data.project
      && data.project.projectFormAccessibilities
      && templates
      && templates.data
      && templates.data.print
    ) {
      data.project.projectFormAccessibilities.forEach((pfa) => {
        const isAllowedToView = this.checkIfFormAccessibleToViewForm(pfa, data);
        if (isAllowedToView) {
          const selectedTemplate = templates.data.print.find(pt => pt.id === pfa.templateID);
          if (selectedTemplate && selectedTemplate.name && selectedTemplate.id) {
            output.push({ value: selectedTemplate.id, text: selectedTemplate.name });
          }
        }
      });
    }
    // if (data
    //   && data.project
    //   && data.project.bobFormIDs
    //   && bobForms
    //   && bobForms.data
    // ) {
    //   data.project.bobFormIDs.forEach((pbf) => {
    //     bobForms.data.forEach((bf) => {
    //       if (pbf === bf.id) {
    //         output.push({
    //           value: pbf,
    //           text: bf.title,
    //           type: 'BOB',
    //         });
    //       }
    //     });
    //   });
    // }

    // add IC options if customer has IC images uploaded
    if (data && data.bookingCustomers && data.bookingCustomers.length > 0) {
      if (data.bookingCustomers.some(bc => this.checkICIsImage(bc.customer))) {
        output.push({
          value: 'customer_identities',
          text: t('Purchasers’ IC'),
        });
      }
    }

    this.setState({ printTemplates: output });
  }

  async fetchDocxTemplates(data) {
    const { store } = this.context;
    const { t, auth } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/docxtemplates/projects/${data.project.id}/templates/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      this.setState({ docxPrintTemplates: [] });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      this.setState({ docxPrintTemplates: [] });
    } else {
      const docxPrintTemplates = await res.json();
      let tempTemplates = [];
      if (docxPrintTemplates && docxPrintTemplates.length > 0) {
        const statusFieldMap = {
          reserved: 'isEnabledOnReserved',
          booked: 'isEnabledOnBooked',
          cancelled_developer: 'isEnabledOnCancelled',
          cancelled_availability: 'isEnabledOnCancelled',
          sold: 'isEnabledOnSold',
          sold_spa_signed: 'isEnabledOnSold',
        };
        const field = statusFieldMap[data.statusID];
        tempTemplates = docxPrintTemplates
          .filter(template => template.isEnabled && field && template[field] && Array.isArray(template.visibleToBusinessUnits) && template.visibleToBusinessUnits.includes(auth.companyBranch.id))
          .map(template => ({
            value: template.id,
            text: template.name.replace('.docx', ''),
            type: 'docx',
          }));
      }
      // always set state so templates from a previous booking are cleared when the
      // current project has none (MS-6015), without resetting on unrelated props changes (MS-6448)
      this.setState({ docxPrintTemplates: tempTemplates });
    }
  }

  checkAutoReleaseTimer = async () => {
    const { allBankCases, data, systemData, project } = this.state;
    // if booking is reserved & system's AR is turned on
    if (data && data.statusID === 'reserved' && systemData && project && systemData.arBookingExpIsEnabled) {
       const primaryBookingCustomer =
         (data.bookingCustomers && data.bookingCustomers.find(bc => bc.customerID === data.customerID)) ||
         data.bookingCustomer;

      const systemTimer = systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
      const projectTimer = project.arBookingExpMoreThanMinutes !== '' && project.arBookingExpMoreThanMinutes !== '0';
      const hasFrontIC = primaryBookingCustomer && primaryBookingCustomer.customer && primaryBookingCustomer.customer.icFrontDocumentID;
      const hasBackIC = primaryBookingCustomer && primaryBookingCustomer.customer && primaryBookingCustomer.customer.icBackDocumentID;
      const hasPaid = data.paymentStatusID && data.paymentStatusID === 'paid';
      const hasMortgageAdded = allBankCases && allBankCases.length > 0;
      const isBankerSourceOfFinance = data.paymentMethodID === 'own_banker' || data.paymentMethodID === 'referred_banker';
      const allPurchasersHasUploadedIC = data.bookingCustomers && data.bookingCustomers.length > 0 && data.bookingCustomers.filter(c => !c.customer.icFrontDocumentID || !c.customer.icBackDocumentID).length === 0;

      if (systemTimer || projectTimer) {
        const sysARPaymentEnabled = systemData.arBookingExpUnpaidIsEnabled;
        const sysARNricEnabled = systemData.arBookingExpNricPicIsEnabled;
        const sysARAllNricEnabled = systemData.arBookingExpAllNricPicsIsEnabled;
        const sysARMortgageEnabled = systemData.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

        const projARPaymentEnabled = project.arBookingExpUnpaidIsEnabled;
        const projARNricEnabled = project.arBookingExpNricPicIsEnabled;
        const projARAllNricEnabled = project.arBookingExpAllNricPicsIsEnabled;
        const projARMortgageEnabled = project.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

        // if either one of the system's requirements is enabled
        if (sysARPaymentEnabled || sysARNricEnabled || sysARAllNricEnabled || sysARMortgageEnabled) {
          // Payment enabled & payment condition fulfilled
          const sysConditionFulfilledPayment = sysARPaymentEnabled && hasPaid;
          // IC enabled & IC condition fulfilled
          let sysConditionFulfilledNric = sysARNricEnabled && hasBackIC && hasFrontIC;
          // Additional Purchasers IC enabled & all IC condition fulfilled
          if (sysARAllNricEnabled) {
            sysConditionFulfilledNric = allPurchasersHasUploadedIC;
          }
          // All IC enabled & All IC condition fulfilled
          // Mortgage enabled & mortgage condition fulfilled
          const sysConditionFulfilledMortgage = sysARMortgageEnabled && hasMortgageAdded;
          if (
            // all enabled and all conditions fulfilled
            (sysConditionFulfilledPayment && sysConditionFulfilledNric && sysARMortgageEnabled) ||
            // IC & mortgage enabled & both conditions fulfilled, payment disabled
            (!sysARPaymentEnabled && sysConditionFulfilledNric && sysConditionFulfilledMortgage) ||
            // Payment & mortgage enabled & both conditions fulfilled, NRIC disabled
            (sysConditionFulfilledPayment && !sysARNricEnabled && sysConditionFulfilledMortgage) ||
            // Payment & IC enabled & both conditions fulfilled, mortgage disabled
            (sysConditionFulfilledPayment && sysConditionFulfilledNric && !sysARMortgageEnabled) ||
            // Mortgage enabled & mortgage condition fulfilled, payment & nric disabled
            (!sysARPaymentEnabled && !sysARNricEnabled && sysConditionFulfilledMortgage) ||
            // IC enabled & IC condition fulfilled, payment & mortgage disabled
            (!sysARPaymentEnabled && sysConditionFulfilledNric && !sysARMortgageEnabled) ||
            // Payment enabled & payment condition fulfilled, nric & mortgage disabled
            (sysConditionFulfilledPayment && !sysARNricEnabled && !sysARMortgageEnabled)
            ) {
            this.setState({ isAutoReleaseTimerEnabled: false });
            return;
          }
        // if project AR is turned on & 1 of the requirements is enabled
        } else if (project.arBookingExpIsEnabled && (projARPaymentEnabled || projARNricEnabled || projARAllNricEnabled || projARMortgageEnabled)) {
          // Payment enabled & payment condition fulfilled
          const projConditionFulfilledPayment = projARPaymentEnabled && hasPaid;
          // IC enabled & IC condition fulfilled
          let projConditionFulfilledNric = projARNricEnabled && hasBackIC && hasFrontIC;
          // Additional Purchasers IC enabled & all IC condition fulfilled
          if (projARAllNricEnabled) {
            projConditionFulfilledNric = allPurchasersHasUploadedIC;
          }
          // Mortgage enabled & mortgage condition fulfilled
          const projConditionFulfilledMortgage = projARMortgageEnabled && hasMortgageAdded;
          if (
            // all enabled and all conditions fulfilled
            (projConditionFulfilledPayment && projConditionFulfilledNric && projARMortgageEnabled) ||
            // IC & mortgage enabled & both conditions fulfilled, payment disabled
            (!projARPaymentEnabled && projConditionFulfilledNric && projConditionFulfilledMortgage) ||
            // Payment & mortgage enabled & both conditions fulfilled, NRIC disabled
            (projConditionFulfilledPayment && !projARNricEnabled && projConditionFulfilledMortgage) ||
            // Payment & IC enabled & both conditions fulfilled, mortgage disabled
            (projConditionFulfilledPayment && projConditionFulfilledNric && !projARMortgageEnabled) ||
            // Mortgage enabled & mortgage condition fulfilled, payment & nric disabled
            (!projARPaymentEnabled && !projARNricEnabled && projConditionFulfilledMortgage) ||
            // IC enabled & IC condition fulfilled, payment & mortgage disabled
            (!projARPaymentEnabled && projConditionFulfilledNric && !projARMortgageEnabled) ||
            // Payment enabled & payment condition fulfilled, nric & mortgage disabled
            (projConditionFulfilledPayment && !projARNricEnabled && !projARMortgageEnabled)
            ) {
            this.setState({ isAutoReleaseTimerEnabled: false });
            return;
          }
        // project AR is not on
        } else if (!project.arBookingExpIsEnabled) {
          this.setState({ isAutoReleaseTimerEnabled: false });
          return;
        // none of the requirements is on
        } else if (!sysARPaymentEnabled && !sysARNricEnabled && !sysARAllNricEnabled && !sysARMortgageEnabled && !projARPaymentEnabled && !projARNricEnabled && !projARAllNricEnabled && !projARMortgageEnabled) {
          this.setState({ isAutoReleaseTimerEnabled: false });
          return;
        }
        this.setState({ isAutoReleaseTimerEnabled: true });
        return;
      }
    }
    this.setState({ isAutoReleaseTimerEnabled: false });
  }
  checkAgingArEnabled = async () => {
    const { data, systemData, project } = this.state;

    const requirementStatusCategories = ['reserved', 'booked'];
    // booking not fall under reserved or booked
    if (!requirementStatusCategories.includes(data.statusID)) {
      this.setState({ isAgingARTimerEnabled: false });
      return;
    }

    if (data && systemData && project && systemData.arBookingExpIsEnabled) {
      const systemTimer = systemData.arAgingBookingExpMoreThanMinutes !== '' && systemData.arAgingBookingExpMoreThanMinutes !== '0';
      const projectTimer = project.arAgingBookingExpMoreThanMinutes !== '' && project.arAgingBookingExpMoreThanMinutes !== '0';

      if (systemTimer || projectTimer) {
        const sysReleaseBookedBookingIsEnabled = systemData.arAgingBookingExpBookedIsEnabled;
        const sysReleaseReservedBookingIsEnabled = systemData.arAgingBookingExpReservedIsEnabled;

        const projReleaseBookedBookingIsEnabled = project.arAgingBookingExpBookedIsEnabled;
        const projReleaseReservedBookingIsEnabled = project.arAgingBookingExpReservedIsEnabled;

        // if either one of the system's requirements is enabled
        if (sysReleaseBookedBookingIsEnabled || sysReleaseReservedBookingIsEnabled) {
          // booking is booked, system no release booked
          if ((data.statusID === 'booked' && !sysReleaseBookedBookingIsEnabled) ||
          // booking is reserved, system no release reserved
          (data.statusID === 'reserved' && !sysReleaseReservedBookingIsEnabled)) {
            this.setState({ isAgingARTimerEnabled: false });
            return;
          }
        // if project AR is turned on & 1 of the requirements is enabled
        } else if (project.arBookingExpIsEnabled && (projReleaseBookedBookingIsEnabled || projReleaseReservedBookingIsEnabled)) {
          // booking is booked, system no release booked
          if ((data.statusID === 'booked' && !projReleaseBookedBookingIsEnabled) ||
          // booking is reserved, system no release reserved
          (data.statusID === 'reserved' && !projReleaseReservedBookingIsEnabled)) {
            this.setState({ isAgingARTimerEnabled: false });
            return;
          }
        // project AR is not on
        } else if (!project.arBookingExpIsEnabled) {
          this.setState({ isAgingARTimerEnabled: false });
          return;
        // none of the requirements is on
        } else if (!sysReleaseBookedBookingIsEnabled && !sysReleaseReservedBookingIsEnabled && !projReleaseBookedBookingIsEnabled && !projReleaseReservedBookingIsEnabled) {
          this.setState({ isAgingARTimerEnabled: false });
          return;
        }
        this.setState({ isAgingARTimerEnabled: true });
        return;
      }
    }
    this.setState({ isAgingARTimerEnabled: false });
  }
  getAllBankCases = (bankCases, bankCaseDrops) => {
    let hasDropCase = false;
    let allCases = [];
    if (bankCases) {
      const bankerIDs = new Set(bankCases.map(bc => bc.bankerID));
      allCases = bankCaseDrops ? [...bankCases, ...bankCaseDrops.filter((bcd) => {
        if (!bankerIDs.has(bcd.bankerID)) {
          hasDropCase = true;
          return true;
        }
      })] : [...bankCases];
    } else if (bankCaseDrops) {
      allCases = [...bankCaseDrops];
      hasDropCase = true;
    }

    this.setState({ allBankCases: allCases, hasDropCase }, () => {
      if (this.state.data && this.state.data.projectID) {
        this.fetchProject(this.state.data.projectID);
      }
    });
  }
  getCountdownText = () => {
    const { systemData, project, data } = this.state;
    const { t } = this.props;
    let text = '';
    const translatedAnd = ` ${t('and', { ns: TRANSLATION_FILES.translation })} `;
    const nricText = t('upload Primary Purchaser(s) IC copy');
    const allNricText = t('upload All Purchasers IC copy');
    const paymentText = t('make Booking fee payment');
    const mortgageText = t('add Banker(s)');
    const isBankerSourceOfFinance = data.paymentMethodID === 'own_banker' || data.paymentMethodID === 'referred_banker';
    const systemArExpMortgageEnabled = systemData && systemData.arBookingExpMortgageEnabled && isBankerSourceOfFinance;
    const projectArExpMortgageEnabled = project && project.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

    // system AR is turned on
    if (systemData && systemData.arBookingExpIsEnabled) {
      // at least 1 of the requirements is turned on
      if (systemData.arBookingExpNricPicIsEnabled || systemData.arBookingExpAllNricPicsIsEnabled || systemData.arBookingExpUnpaidIsEnabled || systemArExpMortgageEnabled) {
        const systemExpNricIsEnabled = systemData.arBookingExpAllNricPicsIsEnabled || systemData.arBookingExpNricPicIsEnabled;
        let systemNricText = nricText;
        if (systemData.arBookingExpAllNricPicsIsEnabled) {
          systemNricText = allNricText;
        }
        // all requirements are turned on
        if (systemExpNricIsEnabled && systemData.arBookingExpUnpaidIsEnabled && systemArExpMortgageEnabled) {
          text = text.concat(systemNricText, ', ', paymentText, translatedAnd, mortgageText);
        // payment & mortgage are turned on
        } else if (!systemExpNricIsEnabled && systemData.arBookingExpUnpaidIsEnabled && systemArExpMortgageEnabled) {
          text = text.concat(paymentText, translatedAnd, mortgageText);
        // nric & mortgage are turned on
        } else if (systemExpNricIsEnabled && !systemData.arBookingExpUnpaidIsEnabled && systemArExpMortgageEnabled) {
          text = text.concat(systemNricText, translatedAnd, mortgageText);
        // nric & payment are turned on
        } else if (systemExpNricIsEnabled && systemData.arBookingExpUnpaidIsEnabled && !systemArExpMortgageEnabled) {
          text = text.concat(systemNricText, translatedAnd, paymentText);
        // mortgage is turned on
        } else if (!systemExpNricIsEnabled && !systemData.arBookingExpUnpaidIsEnabled && systemArExpMortgageEnabled) {
          text = mortgageText;
        // payment is turned on
        } else if (!systemExpNricIsEnabled && systemData.arBookingExpUnpaidIsEnabled && !systemArExpMortgageEnabled) {
          text = paymentText;
        // nric is turned on
        } else if (systemExpNricIsEnabled && !systemData.arBookingExpUnpaidIsEnabled && !systemArExpMortgageEnabled) {
          text = systemNricText;
        }
      // project AR is on & 1 of the requirements is turned on
      } else if (project && project.arBookingExpIsEnabled && (project.arBookingExpNricPicIsEnabled || project.arBookingExpAllNricPicsIsEnabled || project.arBookingExpUnpaidIsEnabled || projectArExpMortgageEnabled)) {
        const projectExpNricIsEnabled = project.arBookingExpAllNricPicsIsEnabled || project.arBookingExpNricPicIsEnabled;
        let projectNricText = nricText;
        if (project.arBookingExpAllNricPicsIsEnabled) {
          projectNricText = allNricText;
        }
        // all requirements are turned on
        if (projectExpNricIsEnabled && project.arBookingExpUnpaidIsEnabled && projectArExpMortgageEnabled) {
          text = text.concat(projectNricText, ', ', paymentText, translatedAnd, mortgageText);
        // payment & mortgage are turned on
        } else if (!projectExpNricIsEnabled && project.arBookingExpUnpaidIsEnabled && projectArExpMortgageEnabled) {
          text = text.concat(paymentText, translatedAnd, mortgageText);
        // nric & mortgage are turned on
        } else if (projectExpNricIsEnabled && !project.arBookingExpUnpaidIsEnabled && projectArExpMortgageEnabled) {
          text = text.concat(projectNricText, translatedAnd, mortgageText);
        // nric & payment are turned on
        } else if (projectExpNricIsEnabled && project.arBookingExpUnpaidIsEnabled && !projectArExpMortgageEnabled) {
          text = text.concat(projectNricText, translatedAnd, paymentText);
        // mortgage is turned on
        } else if (!projectExpNricIsEnabled && !project.arBookingExpUnpaidIsEnabled && projectArExpMortgageEnabled) {
          text = mortgageText;
        // payment is turned on
        } else if (!projectExpNricIsEnabled && project.arBookingExpUnpaidIsEnabled && !projectArExpMortgageEnabled) {
          text = paymentText;
        // nric is turned on
        } else if (projectExpNricIsEnabled && !project.arBookingExpUnpaidIsEnabled && !projectArExpMortgageEnabled) {
          text = projectNricText;
        }
      }
    }

    return `${t('Please {{text}} as required in this time frame. If not, your reservation will be auto-released.', { text })}`;
  }
  getAgingCountdownText = () => {
    const { systemData, project, data } = this.state;
    let text = '';
    const { t } = this.props;

    const bookedText = t('Sold or Cancelled');
    const reservedText = t('Booked, Sold or Cancelled');

    const sysReleaseBookedBookingIsEnabled = systemData.arAgingBookingExpBookedIsEnabled;
    const sysReleaseReservedBookingIsEnabled = systemData.arAgingBookingExpReservedIsEnabled;

    const projReleaseBookedBookingIsEnabled = project.arAgingBookingExpBookedIsEnabled;
    const projReleaseReservedBookingIsEnabled = project.arAgingBookingExpReservedIsEnabled;

    const arAgingStatusesID = ['booked', 'reserved'];

    // system AR is turned on
    if (systemData && systemData.arBookingExpIsEnabled) {
      // at least 1 of the requirements is turned on
      if (sysReleaseBookedBookingIsEnabled || sysReleaseReservedBookingIsEnabled) {
        if (sysReleaseBookedBookingIsEnabled && sysReleaseReservedBookingIsEnabled && arAgingStatusesID.includes(data.statusID)) {
          text = bookedText;
        } else if (sysReleaseBookedBookingIsEnabled && data.statusID === 'booked') {
          text = bookedText;
        } else if (sysReleaseReservedBookingIsEnabled && data.statusID === 'reserved') {
          text = reservedText;
        }
      // project AR is on & 1 of the requirements is turned on
      } else if (project && project.arBookingExpIsEnabled && (projReleaseBookedBookingIsEnabled || projReleaseReservedBookingIsEnabled)) {
        if (projReleaseBookedBookingIsEnabled && projReleaseReservedBookingIsEnabled && arAgingStatusesID.includes(data.statusID)) {
          text = bookedText;
        } else if (projReleaseBookedBookingIsEnabled && data.statusID === 'booked') {
          text = bookedText;
        } else if (projReleaseReservedBookingIsEnabled && data.statusID === 'reserved') {
          text = reservedText;
        }
      }
    }

    return `${t('This reservation is not converted to {{text}} yet. Convert your reservation within the time limit or it will be auto-released.', { text })}`;
  }
  getBookingPaymentPlan = async (bookingID) => {
    this.setState({ loading: true });
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${bookingID}/payment_plan/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      this.setState({ loading: false });
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const bookingPaymentPlan = await res.json();
      // mutate payment plan tab's description
      const sectionTabs = _.map(this.state.sectionTabs, (st) => {
        const nst = { ...st };
        if (st.id === 4) nst.description = this.generatePaymentPlanTabDescription(bookingPaymentPlan);
        return nst;
      });
      this.setState({ bookingPaymentPlan, sectionTabs });
    }
    this.setState({ loading: false });
  }
  fetchBankCaseDrops = async (booking) => {
    await this.setState({ loading: true });
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${booking.id}/loan_trackers/bank_cases/drop/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setState({ loading: false });
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      if (data && data.length > 0) {
        this.getAllBankCases(booking.bankCases, data);
      } else {
        this.getAllBankCases(booking.bankCases);
      }
    }
    await this.setState({ loading: false });
  }
  hasAccess(check = false, admin = true, dhq = true, dbl = true, internal = false) {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  handleFetchAllBankCases = (data) => {
    if (data.loanTrackerLeadID > 0 &&
      data.project &&
      data.project.autoAssignBankerStatus !== '' &&
      data.project.autoAssignBankerStatus === 'booked' &&
      data.statusID === 'reserved') {
      this.fetchBankCaseDrops(data);
    } else {
      this.getAllBankCases(data.bankCases);
    }
  }
  handlePrint = () => {
    Auth.currentSession();
  }
  handlePrintForm = async (e, form, isPDF, type = '') => {
    const { data } = this.state;
    if (form && form.value) {
      const query = isPDF ? '?pdf=true' : '';
      if (type === 'BOB') {
        const bobQuery = isPDF ? `?formID=${form.value}&pdf=true` : `?formID=${form.value}`;
        window.open(`${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/bob/${bobQuery}`, '_blank');
        return;
      }
      // URL to print all purchasers' IC
      if (form.value === 'customer_identities') {
        window.open(`${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/identities/${query}`, '_blank');
        return;
      }
      if (type === 'docx') {
        this.setState({ isPrinting: true });
        try {
          await this.handlePrintDocxTemplate(form.value);
        } catch (error) {
          console.error('An error occurred during DOCX generation.', error);
        } finally {
          this.setState({ isPrinting: false });
        }
        return;
      }
      window.open(`${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/template/${btoa(form.value)}/print/${query}`, '_blank');
    }
  }
  handlePrintDocxTemplate = async (form) => {
    const { data } = this.state;
    const { store } = this.context;
    let templateName = 'template';
    const { docxPrintTemplates } = this.state;
    const template = docxPrintTemplates.find(t => t.value === form);
    if (template) {
      templateName = template.text.replace(/[^a-zA-Z0-9_-]/g, '_');
    }

    let res;
    try {
      res = await store.dispatch(fetchM(`/docxtemplates/templates/${form}/print/?bookingID=${data.id}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        throw err;
      }
      store.dispatch(flashErrorMessage(err));
      throw err;
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
    const downloadLink = document.createElement('a');
    downloadLink.href = url;

    const contentDisposition = res.headers.get('Content-Disposition');
    let filename = `${data.id}_${templateName}.pdf`;

    if (contentDisposition) {
      let filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;,\n\r]+)/);
      if (!filenameMatch) {
        filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
      }
      if (!filenameMatch) {
        filenameMatch = contentDisposition.match(/filename=([^;,\n\r]+)/);
      }
      if (filenameMatch && filenameMatch[1]) {
        filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
      }
    }
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
  }
  getPrintLink = (data, form) => {
    if (form.value === 'customer_identities') {
      return `${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/identities/`;
    }
    return `${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/template/${btoa(form.value)}/print/`;
  }
  generatePaymentPlanTabDescription = (bookingPaymentPlan) => {
    if (bookingPaymentPlan && !_.isEmpty(bookingPaymentPlan.id)) {
      const isEdited = _.some(bookingPaymentPlan.bookingPaymentPlanDetails, bppd => bppd.customized);
      return `${bookingPaymentPlan.code}${isEdited ? ' (edited)' : ''}`;
    }
    return 'Pending Selection';
  };
  async fetchProject(projectID) {
    await this.setState({ loading: true });
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setState({ loading: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const projectToken = res.headers.get('X-Csrf-Token');
      const project = await res.json();
      await this.setState({
        projectToken,
        project,
      });
      if (!isPRS) {
        await this.checkAutoReleaseTimer();
        await this.checkAgingArEnabled();
      }
    }
    await this.setState({ loading: false });
  }
  async fetchSystemSettings() {
    await this.setState({ loading: true });
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setState({ loading: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const systemData = await res.json();
      await this.setState({
        systemData,
      });
    }
    await this.setState({ loading: false }, () => {
      if (this.state.data && this.state.data.project) {
        this.handleFetchAllBankCases(this.state.data);
      }
    });
  }
  async fetchMaUserAffiliateCompanyBranch(branchID) {
    await this.setState({ loading: true });
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/${branchID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      if (data.name) {
        await this.setState({ maUserAffiliateCompanyBranchName: data.name });
      }
    }
    await this.setState({ loading: true });
  }
  async sendEmail(body) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t, token } = this.props;
    const { data } = this.state;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${data.id}/customers/${data.bookingCustomer.customerID}/send_email/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
        body: JSON.stringify(body),
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({
        header: t('Share Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Successfully generate and send email to primary purchaser', { ns: TRANSLATION_FILES.translation }),
      }));
    }
    await this.setLoading(false);
  }
  async updateProject(project, link) {
    const { store } = this.context;
    const { t } = this.props;
    await this.setState({ loading: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${project.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.projectToken,
        },
        body: JSON.stringify(project),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage(t('An error occured', { ns: TRANSLATION_FILES.translation })));
    }
    const projectData = await res.json();
    await this.setState({ project: projectData, loading: false }, () => {
      window.open(link, '_blank');
    });
  }
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
      this.setState({ ...state });
    }
  }
  handleCountdownFinish = () => {
    const { store } = this.context;
    const location = this.props.location;
    store.dispatch(replace(location.pathname + location.search));
    this.setState({ refreshPage: true });
  }
  handleOnOpenShareEmail = (e) => {
    e.preventDefault();
    this.setState({ showShareEmailModal: true });
  }
  handleOnCloseShareEmail = (e) => {
    e.preventDefault();
    this.setState({ showShareEmailModal: false });
  }
  handleProceedShareEmail = (e, data) => {
    e.preventDefault();
    this.sendEmail(data);
  }
  handleTabChange = (tabData) => {
    if (!tabData) return;
    const tabID = tabData.id;
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);
    let tab = 'info';
    switch (tabID) {
      case 1:
        tab = 'info';
        break;
      case 2:
        tab = 'purchaser';
        break;
      case 3:
        tab = 'tracker';
        break;
      case 4:
        tab = 'payment_plan';
        break;
      case 5:
        tab = 'documents';
        break;
      case 6:
        tab = 'logs';
        break;
      case 7:
        tab = 'buyer';
        break;
      default:
        tab = 'info';
        break;
    }
    query.section = tab;
    this.setState({
      tabID: this.props.checkHasChanges() ? this.state.tabID : tabID,
    });
    if (tabData.page) {
      store.dispatch(push(`/bookings/${this.state.data.id}/${tabData.page}`));
    } else {
      const callback = () => {
        if (this.props.checkHasChanges()) {
          this.props.onCheck(false, this.setState({ tabID }));
        }
        if (tabData.isSticky) {
          // Scrolltop
          window.scrollTo(0, 150);
        }
        store.dispatch(replace(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
      };
      if (this.props.checkHasChanges()) {
        store.dispatch(promptChangesMessage({ message: DEFAULT_PROMPT, callback }));
      } else {
        callback();
      }
    }
  }
  checkIfAgingBannerIsVisible = () => {
    const { isAutoReleaseTimerEnabled, project, systemData } = this.state;
    const systemTimer = systemData && systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
    if (systemTimer && Number(systemData.arBookingExpMoreThanMinutes) === Number(systemData.arAgingBookingExpMoreThanMinutes)) return true;
    if (!systemTimer && Number(project.arBookingExpMoreThanMinutes) === Number(project.arAgingBookingExpMoreThanMinutes)) return true;
    return !isAutoReleaseTimerEnabled;
  }
  renderAutoRelease = () => {
    const { data, isAutoReleaseTimerEnabled, project, systemData } = this.state;
    const { t } = this.props;
    const systemTimer = systemData && systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';

    // checking for AR start based on arBookingStartDate
    const afterProjectSettingDate = moment(project.arBookingStartDate).diff(moment(data.createdAt)) <= 0;
    const enabledForBookingStartDate = !project.arBookingAllUnderReserved && project.arBookingStartDate && afterProjectSettingDate;

    if (isPRS) {
      return (
        <AutoReleaseTimer
          data={data}
          countdownSeconds={3660}
          countdownText={t('Please fill in all the details or upload Purchaser(s) IC copy as required in this time frame. If not, your reservation will auto-released in 1 hour.')}
          handleCountdownFinish={this.handleCountdownFinish}
        />
      );
    }
    if (isAutoReleaseTimerEnabled && (project.arBookingAllUnderReserved || enabledForBookingStartDate)) {
      return (
        <AutoReleaseTimer
          data={data}
          countdownSeconds={systemTimer ? Number(systemData.arBookingExpMoreThanMinutes) * 60 : Number(project.arBookingExpMoreThanMinutes) * 60}
          countdownText={this.getCountdownText()}
          handleCountdownFinish={this.handleCountdownFinish}
        />
      );
    }
    return null;
  }
  renderAgingAutoRelease = () => {
    const { data, isAgingARTimerEnabled, project, systemData } = this.state;
    const systemTimer = systemData && systemData.arAgingBookingExpMoreThanMinutes !== '' && systemData.arAgingBookingExpMoreThanMinutes !== '0';

    // checking for AR start based on arBookingStartDate
    const afterProjectSettingDate = moment(project.arBookingStartDate).diff(moment(data.createdAt)) <= 0;
    const enabledForBookingStartDate = !project.arBookingAllUnderReserved && project.arBookingStartDate && afterProjectSettingDate;

    if (isAgingARTimerEnabled && (project.arBookingAllUnderReserved || enabledForBookingStartDate)) {
      return (
        <AutoReleaseTimer
          data={data}
          countdownSeconds={systemTimer ? Number(systemData.arAgingBookingExpMoreThanMinutes) * 60 : Number(project.arAgingBookingExpMoreThanMinutes) * 60}
          countdownText={this.getAgingCountdownText()}
          handleCountdownFinish={this.handleCountdownFinish}
        />
      );
    }
    return null;
  }
  render() {
    const {
      allBankCases,
      data,
      hasDropCase,
      loading,
      isMobile,
      printTemplates,
      tabID,
      sectionTabs,
      maUserAffiliateCompanyBranchName,
      refreshPage,
      docxPrintTemplates,
    } = this.state;
    const { t, auth } = this.props;
    const printTmplOnly = printTemplates ? printTemplates.filter(({ value }) => value !== 'customer_identities') : [];
    const combinedPrintTemplates = [...docxPrintTemplates, ...printTemplates];
    const combinedPrintTmplOnly = combinedPrintTemplates ? combinedPrintTemplates.filter(({ value }) => value !== 'customer_identities') : [];
    const sectionProps = { ...this.props, combinedPrintTmplOnly, isMobile, maUserAffiliateCompanyBranchName, refreshPage };
    const { isPrinting } = this.state;

    return (
      <Container>
        <NavBar
          header={t(isCountryVietnam(auth.company.countryCode) ? 'Sales Overview' : 'Booking Overview', { ns: TRANSLATION_FILES.translation })}
          rightNav={(this.checkAllowPrint(data && data) || this.canShowVNCancel()) ? (
            <Menu.Item fitted>
              <div className="printButton">
                {/* CPI-974 (E): the print block keeps its own condition, so its output is
                    unchanged; only the wrapper now also opens for the VN cancel action. */}
                {this.checkAllowPrint(data && data) && (
                <React.Fragment>
                  {/* For PDF */}
                  {data.project.printPDF && printTmplOnly.length === 1 ? (
                    <Link
                      as="a"
                      className="ui medium compact primary button icon"
                      disabled={loading}
                      onClick={this.handlePrint}
                      target="_blank"
                      to={`${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/template/${btoa(printTemplates[0].value)}/print/?pdf=true`}
                    >
                      <Icon name="file outline pdf" fitted={isMobile} /><small>{isMobile ? '' : ' PDF'}</small>
                    </Link>
                    ) : data.project.printPDF && printTmplOnly.length > 1 &&
                      <Dropdown
                        pointing="top right"
                        button
                        compact
                        labeled={!isMobile}
                        icon="file outline pdf"
                        text={isMobile ? '' : 'PDF'}
                        className="ui medium compact primary button icon print_dropdown"
                        style={{
                          marginRight: '10px',
                          height: '30px',
                          verticalAlign: 'middle',
                        }}
                      >
                        <Dropdown.Menu>
                          {/* NOTE: print purchasers' IC don't support print PDF now */}
                          {printTmplOnly.map(({ text, value, type }) => (
                            <Dropdown.Item
                              key={`${value}_${text}`}
                              name="printType"
                              value={value}
                              onClick={(e, form) => this.handlePrintForm(e, form, true, type)}
                            >
                              {text}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                  }
                  {/* For HTML/DOCX Print */}
                  {
                    combinedPrintTemplates.length === 1 ?
                      (() => {
                        const template = combinedPrintTemplates[0];
                        const isDocx = template.type === 'docx';
                        const showLoading = isDocx && isPrinting;
                        return (
                          <Link
                            as="a"
                            className={`ui medium compact primary button icon ${showLoading ? 'disabled' : ''}`}
                            disabled={showLoading}
                            onClick={(e) => {
                              e.preventDefault();
                              if (showLoading) return; // Prevent clicking while loading
                              this.handlePrintForm(e, { value: template.value }, false, template.type);
                            }}
                            target="_blank"
                            to={!isDocx ? this.getPrintLink(data, template) : '#'}
                          >
                            {showLoading ? <Icon name="spinner" loading fitted={isMobile} /> : <Icon name="print" fitted={isMobile} />}
                            <small>{isMobile ? '' : ` ${showLoading ? t('Printing...') : t('Print')}`}</small>
                          </Link>
                        );
                      })()
                    :
                      <Dropdown
                        pointing="top right"
                        button
                        labeled={!isMobile}
                        icon="print"
                        text={isMobile ? '' : t('Print')}
                        className="ui medium compact primary button icon print_dropdown"
                        loading={isPrinting}
                        disabled={isPrinting}
                        style={{
                          marginRight: '10px',
                          height: '30px',
                          verticalAlign: 'middle',
                        }}
                      >
                        <Dropdown.Menu>
                          {combinedPrintTemplates.map(({ text, value, type }) => (
                            <Dropdown.Item
                              key={`${value}_${text}`}
                              name="printType"
                              value={value}
                              onClick={(e, form) => this.handlePrintForm(e, form, false, type)}
                            >
                              {text}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                  }
                  {/* For Email share */}
                  { data.project.allowSendFormsEmail && combinedPrintTemplates.length > 0 &&
                    <Popup
                      content={t('Primary purchaser\'s email address is required')}
                      disabled={!!(data.bookingCustomer && data.bookingCustomer.email)}
                      trigger={
                        <div style={{ display: 'inline-block' }}>
                          <Button
                            className="ui medium compact primary button icon"
                            icon
                            labelPosition={isMobile ? '' : 'left'}
                            disabled={data.bookingCustomer && !data.bookingCustomer.email}
                            onClick={this.handleOnOpenShareEmail}
                            style={{ height: '30px', verticalAlign: 'middle', fontSize: '12px' }}
                          >
                            <Icon name="share square" fitted={isMobile} />
                            {isMobile ? '' : t('Share')}
                          </Button>
                        </div>
                      }
                    />
                  }
                  <FormSharingModal
                    open={this.state.showShareEmailModal}
                    onClose={this.handleOnCloseShareEmail}
                    onProceed={this.handleProceedShareEmail}
                    printTemplates={combinedPrintTemplates}
                  />
                </React.Fragment>
                )}
                {this.renderCancelAction()}
              </div>
            </Menu.Item>
          ) : null}
          bottomNode={
            <BookingSectionTab
              loading={this.state.loading}
              isMobile={isMobile}
              isSticky
              onTabChange={this.handleTabChange}
              tabs={sectionTabs}
              tabID={tabID}
            />
          }
        />
        <Grid>
          <Grid.Column>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <BookingSectionTab
                    loading={this.state.loading}
                    isMobile={isMobile}
                    onTabChange={this.handleTabChange}
                    tabs={sectionTabs}
                    tabID={tabID}
                  />
                  {this.renderAutoRelease()}
                  {!isPRS && this.checkIfAgingBannerIsVisible() && this.renderAgingAutoRelease()}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {tabID === 1 && <Info {...sectionProps} />}
            {tabID === 2 && <Purchaser {...sectionProps} />}
            {tabID === 3 && <Tracker {...sectionProps} allBankCases={allBankCases} hasDropCase={hasDropCase} />}
            {tabID === 4 && (<PaymentPlan {...sectionProps} refetchBookingPaymentPlan={this.getBookingPaymentPlan} />)}
            {tabID === 5 && <Documents {...sectionProps} />}
            {tabID === 7 && <Buyer {...sectionProps} />}
          </Grid.Column>
        </Grid>
        {this.renderCancelModal()}
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Overview/Overview.jsx